import {
  Item,
  ItemContent,
  ItemDescription,
  ItemMedia,
  ItemTitle,
} from '@/components/ui/item';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { cn } from '@/lib/cn';
import { Icons } from '@/components/icons';
import {
  TenantConfig,
  type RelationalFieldValue,
  type SubTenant,
  type Tenant,
} from '@pigello/pigello-matrix';

export const WARNING_MESSAGES = {
  highRiskInteraction:
    'Denna kund har blivit markerad med en säkerhetsnotering.',
  wantsEvicted:
    'Denna kund har blivit flaggad för avhysning. Detta innebär att inga nya avtal eller liknande bör skrivas med denna kund.',
} as const;

export function TenantAlertsHeader({ data }: { data?: NoInfer<Tenant> }) {
  if (data?.highRiskInteraction || data?.wantsEvicted)
    return (
      <div className='mb-2 flex flex-col gap-2'>
        {data.highRiskInteraction && (
          <TenantAlert attribute='highRiskInteraction' />
        )}
        {data.wantsEvicted && <TenantAlert attribute='wantsEvicted' />}
      </div>
    );

  return null;
}

export function TenantAlert({
  attribute,
}: {
  attribute: 'highRiskInteraction' | 'wantsEvicted';
}) {
  return (
    <Item size='sm' variant='outline'>
      <ItemMedia variant='icon'>
        <Icons.warning className='size-4 text-destructive' />
      </ItemMedia>

      <ItemContent>
        <ItemTitle>{TenantConfig.fields[attribute].verboseName}</ItemTitle>

        <ItemDescription>{WARNING_MESSAGES[attribute]}</ItemDescription>
      </ItemContent>
    </Item>
  );
}

export function TenantAlertWarningBadge({
  user,
  className,
}: {
  user:
    | Tenant
    | SubTenant
    | RelationalFieldValue<Tenant>
    | RelationalFieldValue<SubTenant>
    | undefined;
  className?: string | undefined;
}) {
  if (!user || (!user.highRiskInteraction && !user.wantsEvicted)) return null;

  return (
    <Tooltip>
      <TooltipTrigger>
        <Icons.warning className={cn('size-4 text-destructive', className)} />
      </TooltipTrigger>

      <TooltipContent className='grid max-w-62 gap-4 text-sm'>
        {user.highRiskInteraction && (
          <p>{WARNING_MESSAGES.highRiskInteraction}</p>
        )}

        {user.wantsEvicted && <p>{WARNING_MESSAGES.wantsEvicted}</p>}
      </TooltipContent>
    </Tooltip>
  );
}
